import { Store } from 'react-notifications-component';

export default function AppNotificationAlert(props) {
  const { title, message, type, position, duration = 5000, ...others } = props;

  if (type) {
    Store.addNotification({
      title: title || 'Info',
      message,
      type: type || 'info',
      insert: 'top',
      container: position || 'top-right',
      animationIn: ['animated', 'fadeIn'],
      animationOut: ['animated', 'fadeOut'],
      dismiss: {
        duration,
        showIcon: duration === 0,
      },
      ...others,
    });
  }
  return null;
}
